import { createContext } from "react";

import CategoryModel from "models/categories/Category";

export const CategoriesContext = createContext<{
	categories: CategoryModel[];
}>({
	categories: [],
});
